<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
        class="table-style"
        stripe
        highlight-hover-row
        show-footer
        show-overflow
        align="center"
        max-height="400"
        border="none"
        :data="orderList"
    >
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
          field="sellerOrdersNum"
          title="子订单编号"
          min-width="130"
      >
        <template v-slot="{ row }">
          <a @click="openOrderDetail(row.id, 2)" style="color: #2d8cf0">{{
            row.sellerOrdersNum
            }}</a>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column field="contractNum" title="关联合同" min-width="150">
        <template v-slot="{ row }">
          <a @click="showDetail(row.contractId)" style="color: #2d8cf0">{{
            row.contractNum
            }}</a>
        </template>
      </vxe-table-column> -->
      <vxe-table-column field="contractBusType" title="业务类型" width="60">
        <template slot-scope="{ row }">
          <span>{{ row.contractBusType | contractbusMap }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="buyerName"
          title="托运人名称"
          min-width="200"
          show-overflow
      ></vxe-table-column>
      <vxe-table-column
          field="sellerName"
          title="承运人名称"
          min-width="200"
          show-overflow
      ></vxe-table-column>
       <vxe-table-column
          field="goodsType"
          title="货物类型"
          width="120"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].goodsType
            }}</span>
          </template>
        </vxe-table-column>
      <vxe-table-column field="goodsName" title="货名" width="105">
        <template slot-scope="{ row, $rowIndex }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].goodsName
          }}</span>
          <Icon
              type="ios-arrow-down"
              @click="clickEvent3($rowIndex)"
              v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
          />
          <vxe-pulldown :ref="$rowIndex" transfer placement="bottom">
            <template v-slot:dropdown>
              <div class="my-dropdown3">
                <vxe-table
                    auto-resize
                    style="width: 1175px"
                    :data="row.goodsRtnVos"
                    stripe
                    show-overflow
                    align="center"
                    :show-header="false"
                >
                  <vxe-table-column
                      field="goodsName"
                      title="货名"
                      width="105"
                  ></vxe-table-column>
                  <vxe-table-column
                      field="rule"
                      title="规格"
                      width="60"
                  ></vxe-table-column>
                  <vxe-table-column
                      field="packUnit"
                      title="包装形式"
                      width="80"
                  ></vxe-table-column>
                  <vxe-table-column
                      field="unit"
                      title="单位"
                      width="60"
                  ></vxe-table-column>
                  <vxe-table-column
                      field="counts"
                      title="数量"
                      width="75"
                  ></vxe-table-column>
                  <vxe-table-column
                      field="price"
                      title="单价"
                      width="75"
                  ></vxe-table-column>
                  <vxe-table-column
                      field="priceType"
                      title="计费方式"
                      width="80"
                  >
                    <template slot-scope="{ row }">
                      <span>{{ row.priceType | priceTypeMap }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column field="isTax" title="含税" width="60">
                    <template slot-scope="{ row }">
                      <span>{{ row.isTax | taxMap }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                      field="carShipNum"
                      title="车船号"
                      width="120"
                  ></vxe-table-column>
                  <vxe-table-column
                      field="beginPlace"
                      title="起运地"
                      width="90"
                  ></vxe-table-column>
                  <vxe-table-column
                      field="endPlace"
                      title="目的地"
                      width="90"
                  ></vxe-table-column>
                  <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
                    <template v-slot="{ row }">
                      <span>{{ row.beginTime | timeFormatDate }}</span>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column field="endTime" title="到达时间" width="140">
                    <template v-slot="{ row }">
                      <span>{{ row.endTime | timeFormatDate }}</span>
                    </template>
                  </vxe-table-column>
                  <!-- <vxe-table-column
                      field="driverName"
                      title="司机"
                      width="100"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="driverPhone"
                      title="手机号"
                      width="120"
                    ></vxe-table-column> -->
                </vxe-table>
              </div>
            </template>
          </vxe-pulldown>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="goodsRtnVos"
          title="规格"
          width="60"
          align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].rule }}</span>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column
          field="goodsRtnVos"
          title="包装形式"
          width="80"
          align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].packUnit
          }}</span>
        </template>
      </vxe-table-column> -->
      <vxe-table-column field="goodsRtnVos" title="单位" width="60">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].unit }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="数量" width="75">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].counts }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="单价" width="75">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{ row.goodsRtnVos[0].price }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="goodsRtnVos"
          title="计费方式"
          width="80"
          align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].priceType | priceTypeMap
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="含税" width="60">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].isTax | taxMap
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="车船号" width="120">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].carShipNum
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="起运地" width="90">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].beginPlace
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
          field="goodsRtnVos"
          title="受载/起运时间"
          min-width="140"
      >
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{row.goodsRtnVos[0].beginTime | timeFormatDate}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="目的地" width="90">
        <template slot-scope="{ row }">
          <span v-if="row.goodsRtnVos[0]">{{
            row.goodsRtnVos[0].endPlace
          }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="goodsRtnVos" title="到达时间" width="140">
        <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{row.goodsRtnVos[0].endTime | timeFormatDate}}</span>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column field="goodsRtnVos" title="司机" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].driverName
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="手机号" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos[0]">{{
              row.goodsRtnVos[0].driverPhone
            }}</span>
          </template>
        </vxe-table-column> -->
    </vxe-table>
    <vxe-pager
        background
        size="small"
        :current-page.sync="page.currentPage"
        :page-size.sync="page.pageSize"
        :total="page.totalResult"
        @page-change="handlePageChange"
        v-if="page.totalResult > 10"
    ></vxe-pager>
    <vxe-modal
        v-model="visible"
        :title="modalTitle"
        width="1300"
        height="650"
        @close="closeCreate"
        resize
        remember
    >
      <create-seller-modal
          ref="modalCreate"
          @close="close"
      ></create-seller-modal>
    </vxe-modal>
    <vxe-modal
        v-model="viewBuyer"
        title="查看承运人合同"
        width="1300"
        height="650"
        @close="closeDetail"
        resize
        remember
    >
      <view-detail-modal
          ref="modalDetail"
          @goEdit="goEdit"
          :editVisible="isHavePermission('seller:updateContract')"
      ></view-detail-modal>
    </vxe-modal>
  </div>
</template>

<script>
  import ViewDetailModal from "@/views/agreement/ViewDetailModal";
  import CreateSellerModal from "@/views/agreement/CreateSellerModal";
  import viewOrderDetail from "@/mixin/viewOrderDetail";
  import $api from "@/apiProvider";
  import getAuthOrization from "@/mixin/getAuthOrization";

  export default {
    mixins: [getAuthOrization, viewOrderDetail],
    components: {
      ViewDetailModal,
      CreateSellerModal,
    },
    props: {
      id: String,
    },
    data() {
      return {
        viewBuyer: false,
        contractId: null,
        visible: false,
        modalTitle: "",
        orderList: [],
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 0,
        },
      };
    },
    created() {
      this.getAboutOrder();
      this.$bus.$on("isGetAboutOrder", (data) => {
        if (data === true) {
          this.getAboutOrder();
        }
      });
    },
    methods: {
      getAboutOrder() {
        // queryOrdersSellerListMod.el
        let id = parseInt(this.$route.params.id);
        $api.order.queryOrdersSellerListModel
          .POST({
            data: {
              buyerOrdersId: id,
              isSecondSeller: 0,
              page: this.page.currentPage,
              rows: this.page.pageSize,
            },
          })
          .then((res) => {
            if (res.status === 1) {
              this.orderList = res.data.rows;
              this.page.totalResult = res.data.total;
              this.$bus.$emit("isGetAboutOrder", false);
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          });
      },
      handlePageChange(e) {
        // 分页
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.getAboutOrder();
      },
      clickEvent3(id) {
        this.$refs[id].togglePanel();
      },
      showDetail(id) {
        if (!this.isHavePermission('buyer:queryContractDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.contractId = id;
        this.viewBuyer = true;
        this.$refs.modalDetail.queryContractDetail(id);
      },
      closeDetail() {
        this.$refs.modalDetail.close();
      },
      goEdit() {
        this.modalTitle = "编辑承运人合同";
        this.visible = true;
        this.$refs.modalCreate.queryContractDetail(this.contractId);
      },
      closeCreate() {
        this.$refs.modalCreate.close();
      },
      close(value) {
        if (value === "add") {
          this.visible = false;
        } else if (value === "update") {
          this.visible = false;
          this.viewBuyer = false;
          this.$refs.modalDetail.close();
        }
        this.$emit("update");
      },
    },
  };
</script>

<style>
</style>